<template>
  <span>
    <i class="fas fa-user user-icon"></i>
    <span v-for="(n, $index) in names" :key="n">
      {{ n }}<template v-if="numItems === $index">,</template>
    </span>
  </span>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'LinkUserDetail',
    props: {
        id: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default: _ => {return { 'value': [] }},
        },
    },
    computed: {
        names() {
            const ids = _.get(this.value, 'value.value')
            return _.map(ids, id => {
                const user = this.$store.getters.userById(id)
                return _.get(user, 'username')
            })
        },
        numItems() {
            return _.size(_.get(this.value, 'value.value', []))
        },
    },
}
</script>

<style scoped>
.user-icon {
    color: var(--success) !important;
}
</style>
